import {ApplicationInsights} from "@microsoft/applicationinsights-web";
import {environment} from "../../../environments/environment";
import {Injectable} from "@angular/core";

@Injectable({ providedIn: 'root' })
export class LoggerMonitoringService {
	private appInsights: ApplicationInsights | null = null;
	private isInitialized = false;

	public initAppInsights(userId: string, email: string): void {
		if (this.isInitialized) {
			return;
		}

		this.appInsights = new ApplicationInsights({
			config: {
				connectionString: environment.connectionString,
				enableAutoRouteTracking: false,
			}
		});

		this.appInsights.loadAppInsights();
		this.appInsights.setAuthenticatedUserContext(userId);
		this.appInsights.trackPageView({ properties: { email }});
		this.isInitialized = true;
	}
}
